import { createSelector } from 'reselect'
import { getViewedOrder } from 'selectors/orderSelectors'
import determineOrderLoyaltyTransferExperience from './determineOrderLoyaltyTransferExperience'

const getOrderLoyaltyTransferExperience = createSelector(
  (state: App.State) => getViewedOrder(state),
  (state: App.State) => state.experience.experienceLists,
  (state: App.State) => state.experience.experiences,
  determineOrderLoyaltyTransferExperience,
)

export default getOrderLoyaltyTransferExperience
